import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import { PaginatedChristmasBonusDocument, AddChristmasBonusMutation, AddChristmasBonusMutationVariables, AddChristmasBonusDocument } from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for creating a christmas bonus and handling the necessary cache updates.
 * @returns {Object} - Contains the createChristmasBonusMutation function, loading state, and error state.
 */
export default function useAddChristmasBonusMutationHook(): { addChristmasBonusMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [addChristmasBonusMutation, { loading, error }] = useMutation<AddChristmasBonusMutation, AddChristmasBonusMutationVariables>(
    AddChristmasBonusDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedChristmasBonus");

        toast(CustomToastComponent, {
          toastId: "christmas-bonus-added-success",
          data: {
            title: t("toasts.christmasbonusaddedsuccessfully"),
            type: "success",
          }
        });
      },
      refetchQueries: [
        {
          query: PaginatedChristmasBonusDocument,
          variables: {
            first: 10,
            after: null,
            filters: {
              activeFrom: null,
              bonusAbsolute: null,
              bonusRelative: null,
              provinces: null
            },
            sort: null
          }
        }
      ]
    });

  return {
    addChristmasBonusMutation,
    loading,
    error
  };
}
